<template>
  <div class="ms-1 me-1 repair" v-if="repair">
    <div class="col">
      <router-link
        :to="{ name: 'repair-detail', params: { repairId: repair.id } }"
      >
        <div class="name">{{ repair.name }}</div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    repair: {},
  },
  data: function () {
    return {
      accordionShow: false,
    };
  },
  methods: {
    toggleAccordion() {
      this.accordionShow = !this.accordionShow;
    },
  },
};
</script>
<style scoped>
.name {
  font-weight: 400;
  font-size: 18px;
}

p {
  font-weight: 300;
}

.repair {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  width: 100%;
  padding: 10px;
}

.repair a {
  color: black;
  text-decoration: none;
}

.name {
  font-size: 18px;
  text-decoration: underline;
}

.price {
  margin-top: 16px;
}

.gray-text {
  color: rgba(211, 211, 211, 1);
  font-size: 13px;
  text-decoration: none;
}

.cost {
  text-decoration: none;
  color: var(--brand-pink);
  font-size: 12px;
}
</style>
